import {useCallback} from 'react';
import {Card as FabricCard} from '~/common/canvas/Card/Card';
import {CardBackContent} from '~/common/fabric/Card/components/AnimationPreview/components/CardBack';
import {FlipCard} from '~/common/fabric/Card/components/FlipCard/FlipCard';

export const GrcCard = ({fabricArt, message, yourInvitationRef}) => {
  const CardFront = useCallback(() => <FabricCard fabricArt={fabricArt} />, [fabricArt]);

  const CardBack = useCallback(() => <CardBackContent message={message} />, [message]);

  return (
    <div>
      <FlipCard ref={yourInvitationRef} CardFront={CardFront} CardBack={CardBack} />
    </div>
  );
};
